import { NAVY, GOLD } from '../utils/constants';
import { Anchor, Ticket, Users, Wrench, Receipt, Lock, Globe } from 'lucide-react';

const SECTIONS = [
  {
    id: 'cruise-settings',
    icon: Anchor,
    title: 'Cruises & Pricing',
    description: 'Configure cruise types, timings, deck options, and per-passenger pricing',
  },
  {
    id: 'website-content',
    icon: Globe,
    title: 'Website Content',
    description: 'Public website text — per-cruise descriptions and terms & conditions',
  },
  {
    id: 'ticket-preview',
    icon: Ticket,
    title: 'Ticket Design',
    description: 'Customise boarding pass text — boarding point, instructions, footer',
  },
  {
    id: 'partners',
    icon: Users,
    title: 'Partners',
    description: 'Manage travel agencies and partner contacts',
  },
  {
    id: 'maintenance',
    icon: Wrench,
    title: 'Maintenance',
    description: 'Database utilities — generate missing booking references',
  },
  {
    id: 'invoice-settings',
    icon: Receipt,
    title: 'Invoice Settings',
    description: 'GST invoice configuration — company details, SAC codes, tax rates, dinner charges',
  },
  {
    id: 'security-settings',
    icon: Lock,
    title: 'Security',
    description: 'Manage access passwords — Range Reports password',
  },
];

export default function Settings({ onNavigate }) {
  return (
    <div>
      <div className="back-row">
        <button className="back-btn" onClick={() => onNavigate('home')}>← Home</button>
      </div>

      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 800, color: NAVY, marginBottom: 4 }}>Settings</h2>
        <p style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)' }}>Manage partners and pricing configuration</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => onNavigate(s.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#ffffff',
              border: '1px solid var(--color-border)',
              borderRadius: 14,
              padding: '18px 20px',
              cursor: 'pointer',
              textAlign: 'left',
              boxShadow: '0 1px 6px rgba(10,22,40,0.06)',
              transition: 'border-color 0.15s, box-shadow 0.15s',
              width: '100%',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = GOLD;
              e.currentTarget.style.boxShadow = '0 2px 12px rgba(201,168,76,0.18)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--color-border)';
              e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)';
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{
                width: 42,
                height: 42,
                background: 'var(--color-sunken)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20,
                flexShrink: 0,
              }}>
                <s.icon size={22} strokeWidth={1.75} aria-hidden="true" />
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: '0.95rem', color: NAVY }}>{s.title}</div>
                <div style={{ fontSize: '0.78rem', color: 'var(--color-ink-muted)', marginTop: 2 }}>{s.description}</div>
              </div>
            </div>
            <span style={{ color: 'var(--color-ink-faint)', fontSize: '1.4rem', lineHeight: 1, flexShrink: 0 }}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}
